export default __webpack_public_path__ + "static/media/backgroundImg.93d7d72f.svg";